<template>
    <div class="container">
        <div v-if="!isFormVisible" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> Lista de Gestión de Accesos por Roles</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="customOpenCreateModal">
                    <span class="fa-solid fa-plus" />
                    Crear
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <CustomFilters
:order-options="orderOptions" :items-per-page="itemsPerPage" :view-as-card="viewAsCard"
                    :show-deleted="showDeleted" @apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
                    @update-view-as-card="updateViewAsCard" @update-show-deleted="updateShowDeleted" />
                <div v-if="loading" class="loading-indicator">
                    <p>Cargando datos...</p>
                </div>
                <div v-else>
                    <div v-if="filteredItems.length === 0" class="no-records p-5 px-4">
                        <p>No se encontraron registros. Intenta ajustar los filtros o añadir nuevos registros.</p>
                    </div>
                    <div v-else>
                        <div v-if="!viewAsCard" class="table-responsive">
                            <GenericTable
:data="filteredItems" :headers="headers" @delete-record="deleteItem"
                                @edit-record="customOpenEditModal" @restore-record="restoreItem" />
                        </div>
                        <transition-group ref="listContainer" name="fade-move" tag="div" class="row me-2 ms-2 pt-2">
                            <template v-if="viewAsCard">
                                <AppCard
v-for="(item) in filteredItems" :key="item.id" ref="listItems" :data="item"
                                    class="fade-card" @delete-record="deleteItem" @edit-record="customOpenEditModal"
                                    @restore-record="restoreItem" />
                            </template>
                        </transition-group>
                        <Pagination
:total-items="totalFilteredItems" :current-page="currentPage" :last-page="lastPage"
                            :items-per-page="itemsPerPage" @page-change="changePage" />
                    </div>
                </div>
            </div>
        </div>
        <ModelModal
v-if="showModal" v-model="showModal" :is-edit-mode="isEditMode" :resource-api="resourceApi"
            :entity-data="entityData" :display-as-form="displayAsForm" :keep-form-open="keepFormOpen"
            :resource-name="resourceName" @entity-updated="handleEntityUpdated">
            <template #default="{ entity, errors }">
                <div class="col-md-12 mb-3">
                    <div :class="{ 'is-invalid': errors.application_id }">
                        <MenuSelectedFull
v-model="entity.application_id" label="Instancia lógicade negocio"
                            apiurl="applications-by-user" :can-edit-and-add="false" />
                    </div>
                    <div v-if="errors.application_id" class="invalid-feedback">
                        {{ errors.application_id[0] }}
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                    <div :class="{ 'is-invalid': errors.user_id }">
                        <MenuSelectedFull
v-model="entity.user_id" label="Usuario" apiurl="users-application-by-user"
                            :can-edit-and-add="false" />
                    </div>
                    <div v-if="errors.user_id" class="invalid-feedback">
                        {{ errors.user_id[0] }}
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                    <div :class="{ 'is-invalid': errors.role_id }">
                        <MenuSelectedFull
v-model="entity.role_id" label="Rol del usuario"
                            apiurl="roles-modules-permission" :can-edit-and-add="false" />
                    </div>
                    <div v-if="errors.role_id" class="invalid-feedback">
                        {{ errors.role_id[0] }}
                    </div>
                </div>
                <div class="col-md-12 mb-3">
                    <div class="input-label-wrapper">
                        <label class="input-label">
                            <i class="fas fa-th me-2"></i>
                            Módulos asignados
                        </label>
                        <span v-if="(entity.modules?.length || 0) > 0" class="badge-count">
                            {{ entity.modules?.length || 0 }}
                        </span>
                    </div>
                    <ChoicesSelectMultiple
id="choices-modules"
                        v-model="entity.modules"
                        :options="modulesOptions" />
                    <div v-if="errors.modules" class="invalid-feedback d-block">
                        {{ errors.modules[0] }}
                    </div>
                </div>
            </template>
        </ModelModal>
        <div v-if="isFormVisible && displayAsForm" class="card">
            <div class="card-header d-flex justify-content-between align-items-center ps-4 pt-3 pb-4">
                <h5><i class="fa-duotone fa-solid fa-list"></i> {{ isEditMode ? 'Editar' : 'Crear' }} Gestión de Accesos
                    por Instancia</h5>
                <argon-button size="sm" color="primary" variant="gradient" @click="closeForm">
                    <span class="fa-solid fa-arrow-left" />
                    Volver
                </argon-button>
            </div>
            <div class="card-body pt-0">
                <ModelModal
v-model="showModal" :is-edit-mode="isEditMode" :resource-api="resourceApi"
                    :entity-data="entityData" :display-as-form="displayAsForm" :keep-form-open="keepFormOpen"
                    :resource-name="resourceName" @entity-updated="handleEntityUpdated">
                    <template #default="{ entity, errors }">
                        <div class="form-grid">
                            <div class="col-md-12 mb-3">
                                <div :class="{ 'is-invalid': errors.application_id }">
                                    <MenuSelectedFull
v-model="entity.application_id" label="Instancia lógicade negocio"
                                        apiurl="applications-by-user" :can-edit-and-add="false" />
                                </div>
                                <div v-if="errors.application_id" class="invalid-feedback">
                                    {{ errors.application_id[0] }}
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div :class="{ 'is-invalid': errors.user_id }">
                                    <MenuSelectedFull
v-model="entity.user_id" label="Usuario"
                                        apiurl="users-application-by-user" :can-edit-and-add="false" />
                                </div>
                                <div v-if="errors.user_id" class="invalid-feedback">
                                    {{ errors.user_id[0] }}
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div :class="{ 'is-invalid': errors.role_id }">
                                    <MenuSelectedFull
v-model="entity.role_id" label="Rol del usuario"
                                        apiurl="roles-modules-permission" :can-edit-and-add="false" />
                                </div>
                                <div v-if="errors.role_id" class="invalid-feedback">
                                    {{ errors.role_id[0] }}
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <div class="input-label-wrapper">
                                    <label class="input-label">
                                        <i class="fas fa-th me-2"></i>
                                        Módulos asignados
                                    </label>
                                    <span v-if="(entity.modules?.length || 0) > 0" class="badge-count">
                                        {{ entity.modules?.length || 0 }}
                                    </span>
                                </div>
                                <ChoicesSelectMultiple
id="choices-modules-form"
                                    v-model="entity.modules"
                                    :options="modulesOptions" />
                                <div v-if="errors.modules" class="invalid-feedback d-block">
                                    {{ errors.modules[0] }}
                                </div>
                            </div>
                        </div>
                    </template>
                </ModelModal>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import { useModelActions } from '@/composables/useModelActions';
import ModelModal from '@/components/ModelModal.vue';
import CustomFilters from '@/components/CustomFilters.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import Pagination from '@/components/Pagination.vue';
import AppCard from './AppCard.vue';
import GenericTable from '@/components/GenericTable.vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";
import ChoicesSelectMultiple from '@/components/ChoicesSelectMultiple.vue';
import api from '@/services/api';

const resourceApi = 'application-user-roles';
const resourceName = 'Aplicaciónes y Roles';

const orderOptions = [
    { text: 'Fecha de modificación', value: 'updated_at' },
    { text: 'Fecha de creación', value: 'created_at' },
    { text: 'Nombre', value: 'name' }
];

const headers = ref([
    { text: 'Instancia', value: 'application_name' },
    { text: 'Usuario', value: 'user_name' },
    { text: 'Rol', value: 'role_name' },
    { text: 'Creación', value: 'created_at' }
]);

const showModal = ref(false);
const isEditMode = ref(false);
const entityData = ref({
    name: '',
    description: '',
    subscription: '',
    active: true,
    modules: []
});
const modulesOptions = ref([]);
const viewAsCard = ref(true);
const showDeleted = ref(false);
const loading = ref(true);
const displayAsForm = ref(false);
const keepFormOpen = ref(false);
const isFormVisible = ref(false);

const {
    openCreateModal,
    openEditModal,
    handleEntityUpdated,
    applyFilter,
    updateItemsPerPage,
    updateViewAsCard,
    updateShowDeleted,
    restoreItem,
    deleteItem,
    fetchItems,
    changePage,
    filteredItems,
    totalFilteredItems,
    currentPage,
    itemsPerPage,
    lastPage
} = useModelActions(resourceApi, {
    showModal,
    isEditMode,
    entityData,
    viewAsCard,
    showDeleted,
    displayAsForm,
    loading,
    isFormVisible,
    keepFormOpen,
    resourceName
});

const fetchModules = async () => {
    try {
        const response = await api.get('/modules');
        if (response.data && response.data.data) {
            modulesOptions.value = response.data.data.map(m => ({
                value: m.id,
                text: m.name
            }));
        }
    } catch (error) {
        console.error('Error fetching modules:', error);
        modulesOptions.value = [];
    }
};

// Wrapper para openCreateModal
const normalizeModules = (modules) => {
    if (!modules) return [];
    if (!Array.isArray(modules)) return [];
    return modules.map(m => typeof m === 'object' ? m.id : m).filter(Boolean);
};

const customOpenCreateModal = () => {
    openCreateModal({ modules: [] });
};

// Wrapper para openEditModal que garantiza que los módulos estén normalizados
const customOpenEditModal = (entity) => {
    const normalizedModules = normalizeModules(entity.modules);
    openEditModal({
        ...entity,
        modules: normalizedModules
    });
};

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems();
    await fetchModules();
});

const closeForm = () => {
    isFormVisible.value = false;
    fetchItems(currentPage.value);
};

</script>

<style scoped>
.form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}
</style>